var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpportunityRecord = function SvgOpportunityRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3a3 3 0 0 1 3-3h34a3 3 0 0 1 3 3v34a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z",
    fill: "#F3BB6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.88 26.355H13.26c-.3 0-.568.27-.568.568v.03a1.8 1.8 0 0 0 1.794 1.794h10.168a1.8 1.8 0 0 0 1.794-1.794v-.03a.588.588 0 0 0-.568-.568ZM27.346 14.093a1.8 1.8 0 0 0-1.795 1.795c0 .538.24 1.046.628 1.376a3.163 3.163 0 0 1-3.05 1.913 3.16 3.16 0 0 1-2.96-2.96c0-.27 0-.509.059-.748a1.8 1.8 0 0 0 1.136-1.675A1.8 1.8 0 0 0 19.57 12a1.8 1.8 0 0 0-1.794 1.794c0 .748.478 1.406 1.136 1.675.06.24.06.479.06.748a3.16 3.16 0 0 1-2.96 2.96c-1.377.09-2.573-.747-3.051-1.913.389-.33.628-.838.628-1.376a1.8 1.8 0 0 0-1.795-1.795A1.8 1.8 0 0 0 10 15.888a1.8 1.8 0 0 0 1.794 1.794l.838 6.4c.03.27.269.479.568.479h12.74c.27 0 .508-.21.568-.479l.838-6.4a1.8 1.8 0 0 0 1.794-1.794 1.8 1.8 0 0 0-1.794-1.795Z",
    fill: "#fff"
  })));
};

export default SvgOpportunityRecord;